import { render, staticRenderFns } from "./RelatedStore.vue?vue&type=template&id=379ea46d&scoped=true"
import script from "./RelatedStore.vue?vue&type=script&lang=js"
export * from "./RelatedStore.vue?vue&type=script&lang=js"
import style0 from "./RelatedStore.vue?vue&type=style&index=0&id=379ea46d&prod&lang=stylus&scoped=true"
import style1 from "./RelatedStore.vue?vue&type=style&index=1&id=379ea46d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379ea46d",
  null
  
)

export default component.exports